import React from "react";
import classes from "./Home.module.css";
import About from "./About";
import Service from "./Services";
import Book from "./Book";
import Reviews from "./Reviews";

const Home = () => {
  return (
    <div>
        <div>
            {/**
             * Book
             */}
            <Book />
        </div>
      {/**
       * Description of Amplify
       */}
      <div className={classes.clincDesc}>
        <div className={classes.clinicShortDesc}>
          Welcome to Amplify!
          <br />
          <br />
            We are happy to be growing our team to offer Chiropractic care, Massage Therapy and Physiotherapy.
          {/**
           * <br /> This is to make it next line
           */}
          <br />
          <br />
          We are located just off Highway 404 in the north end of Newmarket.
        </div>
      </div>
      {/**
       * About Us
       */}
      <About />
      {/**
       * Service Type
       */}
      <div className={classes.border}>
        <Service />
      </div>
      {/**
       * Reviews
       * <Reviews />
       */}
      <div className={classes.border}>
        <Reviews />
      </div>
    </div>
  );
};

export default Home;
